var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureIcon05(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-90%",
    y: "-90%",
    width: "280%",
    height: "280%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "7.786%",
    y1: "0%",
    x2: "90.938%",
    y2: "49.407%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3039",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A94A7",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.48,
    fill: "#1D2026",
    filter: "url(#a)",
    d: "M38 48h40v40H38z",
    transform: "translate(-9 -17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02CBB1",
    d: "M86.755 88.926l3.46-15.26-39.363 10.387-3.459 15.261z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0270D7",
    d: "M90.735 53.81l7.137-28.53-77.08 20.354-7.137 28.533z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.32,
    fill: "#00BFFB",
    d: "M77.35 14.62l6.442-1.712-11.3-12.65-6.443 1.713z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474C59",
    d: "M46.63 33.718L28.384 61.923l43.659 19.72 18.244-28.206z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00BFFB",
    d: "M29.746 92.298l3.792-3.59-14.732-4-3.793 3.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3039",
    fillRule: "nonzero",
    d: "M17.685 36.372l10.7 25.55 18.339-28.026L35.015 8.122z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "nonzero",
    d: "M49.401 21.254L1.988 27.601l23.588 15.653 47.412-6.346z",
    transform: "rotate(32 52.468 75.451)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon05);
export default __webpack_public_path__ + "static/media/feature-icon-05.969b428e0adfcfe8aafbdedc25f25cc2.svg";
export { ForwardRef as ReactComponent };